var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.267 22.915c0-.782-.515-1.315-1.268-1.315-.756 0-1.27.533-1.27 1.315 0 .781.514 1.314 1.27 1.314.753 0 1.268-.533 1.268-1.314m1.166 0c0 1.385-1.063 2.486-2.434 2.486-1.373 0-2.435-1.101-2.435-2.486 0-1.386 1.062-2.487 2.435-2.487 1.37 0 2.434 1.101 2.434 2.487m-8.472 0c0-.782-.514-1.315-1.269-1.315-.753 0-1.268.533-1.268 1.315 0 .781.515 1.314 1.268 1.314.755 0 1.27-.533 1.27-1.314m1.165 0c0 1.385-1.063 2.486-2.435 2.486-1.37 0-2.435-1.101-2.435-2.486 0-1.386 1.064-2.487 2.435-2.487 1.372 0 2.435 1.101 2.435 2.487m-3.634-5.86h11.626l1.373-7.638H9.19l-.102-1.206H25l-1.852 10.05h-12.69c-2.024 0-2.847-.745-3.086-2.77l-1.03-8.7c-.102-.853-.514-1.208-1.372-1.208H2.5V4.375h2.47c1.817 0 2.469.603 2.675 2.415l.96 8.737c.103 1.066.687 1.527 1.888 1.527"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.f414ca10.svg";
export { ForwardRef as ReactComponent };